import axios from "axios";
import * as config from "../../config";
import UserProfile from '../../UserProfile';

export function getStoreList() {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/store/get', authorization)
    // return axios.get(config.urlAPI + '/store/get?limit=10&page=2', authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getStoreList_map() {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/store/get', authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function addStore(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.post(config.urlAPI + '/store', data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function deleteImg(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.post(config.urlComAPI + '/v1/mobile/image/delete', data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function updateBrand(data) {
    var authorization = config.headerCallAPI
    var token = ''
    // var data = {'state': 'get'}
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.post(config.urlAPI + '/brand/store', data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function storeStatus(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.post(config.urlAPI + '/store/status', data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}